// config/api.js - Configuración automática de API para desarrollo y producción

const getApiUrl = () => {
  // En desarrollo, usar localhost
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
  }
  
  // En producción, usar Render
  if (process.env.REACT_APP_PRODUCTION_API_URL) {
    return process.env.REACT_APP_PRODUCTION_API_URL;
  }
  
  // Fallback basado en el hostname
  if (window.location.hostname.includes('vercel.app') || window.location.hostname.includes('localhost')) {
    // Si está en Vercel o desarrollo, usar Render como backend
    return 'https://banaprecios.onrender.com/api';
  }
  
  // Fallback por defecto
  return 'http://localhost:8000/api';
};

export const API_BASE_URL = getApiUrl();

console.log('🔧 API Configuration:', {
  NODE_ENV: process.env.NODE_ENV,
  hostname: window.location.hostname,
  API_BASE_URL: API_BASE_URL
});
